import { AuthClient } from '@/api/auth-client'
import { TypeformCredentials } from '@/api/model/credentials'
import { TypeformImage } from '@/api/model/typeform/typeform-image'
import { TypeformTheme } from '@/api/model/typeform/typeform-theme'
import { encodeFile } from '@/helpers/file'

export const TypeformAPI = new class TypeformClient extends AuthClient {

    async activate(typeformCredentials: TypeformCredentials) {
        const response = await this.client.post(`/api/v1/service/typeform/activate`, {
            company: typeformCredentials.company.id,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })
    }

    async createImage(file: File): Promise<TypeformImage> {
        const imageData = {
            file_name: file.name,
            image: await encodeFile(file),
        }

        const response = await this.client.post(`/api/v1/service/typeform/images`, imageData, {
            headers: {
                Accept: 'application/json',
            },
        })

        return TypeformImage.fromData(response.data)
    }

    async getTheme(): Promise<TypeformTheme> {
        const response = await this.client.get(`/api/v1/service/typeform/theme`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return TypeformTheme.fromData(response.data)
    }

    async updateTheme(data: any): Promise<TypeformTheme> {
        const response = await this.client.put(`/api/v1/service/typeform/theme`, data.toRequestData(), {
            headers: {
                Accept: 'application/json',
            },
        })

        return await this.getTheme()
    }

}()
